import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  Authenticate,
  OauthAEMConfig,
  SubmitEmailOtp,
  SubmitEmailOtpPayload
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitEmailActivationOtpService {
  submitEmailActivationOtpHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.activateEmailDevice+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  emailActivationOtpSubmit = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    otp: string
  ): Observable<Authenticate> => {
    const emailActivateOtpMethod = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const emailActivationOtpMethodUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: emailActivateOtpMethod
      }
    ];

    const payload: SubmitEmailOtpPayload = {
      otp: otp
    };

    return new ApiBuilder<SubmitEmailOtpPayload, SubmitEmailOtp>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(emailActivationOtpMethodUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitEmailActivationOtpHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_EMAIL_ACTIVATION_OTP')
      .withCredentials(true)
      .create();
  };
}
